import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const WandIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('WandIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 16"
    data-track-tag={dataTrackTag}
  >
    <g clipPath="url(#wand_svg__a)">
      <path
        stroke={getStrokeColor(color)}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="m9.976 3.295 2.728 2.728M3.978 14.75 14.45 4.278c.4-.4.4-1.048 0-1.447L13.17 1.55c-.4-.4-1.047-.4-1.447 0L1.25 12.022zm8.186-4.453c.29 1.293.82 1.77 2.046 2.047-1.293.29-1.77.82-2.046 2.046-.291-1.293-.822-1.77-2.046-2.046 1.292-.291 1.77-.821 2.046-2.046m-9.09-8.892c.219.97.616 1.328 1.535 1.535-.969.218-1.327.616-1.534 1.534-.219-.969-.616-1.327-1.535-1.534.97-.218 1.328-.616 1.535-1.535"
        vectorEffect="non-scaling-stroke"
      />
    </g>
    <defs>
      <clipPath id="wand_svg__a">
        <path d="M0 0h16v16H0z" vectorEffect="non-scaling-stroke" />
      </clipPath>
    </defs>
  </svg>
);
WandIcon.id = 'WandIcon';
WandIcon.displayName = 'WandIcon';
export default WandIcon;
